import React from "react";

const SkeletonRow: React.FC = () => (
  <tr className="animate-pulse">
    {Array(11).fill(0).map((_, idx) => (
      <td key={idx} className="px-6 py-4">
        <div className="h-4 bg-gray-200 rounded w-full"></div>
      </td>
    ))}
  </tr>
);

export default SkeletonRow;
